
import React from 'react';
import LoadBotJs from "../../../client/components/common/LoadBotJs.jsx";
const STATIC_PAGE_PATH = process.env.CMC_PORTAL_STATIC_PAGE_ABSOLUTE_PATH || '/';
//api docs path has changed when accessed from static environment destinations
const DOCUMENTATION_PATH = STATIC_PAGE_PATH !== '/' ? STATIC_PAGE_PATH + 'documentation/v1/' : '/api/v1/';

class Footer extends React.Component {

  render() {

    const year = new Date().getFullYear();

    return (
      <footer className="footer">
        <div className="container">
          <span className="text-muted">&copy; {year} CoinMarketCap</span>
          <nav>
            <ul>
              <li><a href={STATIC_PAGE_PATH + 'pricing/'}>Pricing</a></li>
              <li><a href={DOCUMENTATION_PATH}>API Documentation</a></li>
              <li><a href={STATIC_PAGE_PATH + 'faq/'}>FAQ</a></li>
              <li><a href="https://status.coinmarketcap.com/" target="_blank" rel="noopener noreferrer">API Status</a></li>
            </ul>
          </nav>
        </div>
        <LoadBotJs />
      </footer>
    );
  }
}


export default Footer;



// WEBPACK FOOTER //
// ./client/pages/main/footer.jsx